// src/hooks/productTypes/useGetProductTypes.js
import { useQuery } from "@tanstack/react-query";
import { getAllProductTypes } from "../../api/apiProductTypes";
import i18next from "i18next";

const useGetProductTypes = (page = 1, perPage = 15, filters = {}) => {
    const { data, isLoading, error, refetch, isFetching } = useQuery({
        queryKey: ["productTypes", page, perPage, filters, i18next.language],
        queryFn: () => getAllProductTypes(page, perPage, filters),
        keepPreviousData: true,
    });

    const productTypes = data?.data || [];
    const meta = data?.data?.meta || {};

    return { productTypes, meta, isLoading, error, refetch, isFetching };
};

export default useGetProductTypes; 